import React from "react";

import { Image } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { displayItemTotal } from "@/utils/Helper";
import { getCurrentLang, getUrlLangPrefix } from "@/utils/Local";
import { formatArea, formatMoney, formatWeight } from "@/utils/Toolbox";

import i18n from "../i18n";

import type { ICartItem, ICartItemAttribute } from "@/interfaces/ICart";

interface CartItemInfoComponentProps {
  item: ICartItem;
}

const CartItemInfo: React.FC<CartItemInfoComponentProps> = ({ item }) => {
  const { t } = i18n;
  const lang = getCurrentLang();
  const langPrefix = getUrlLangPrefix();

  return (
    <div className="d-flex align-items-stretch gap-1 cart-item-info-container">
      <div style={{ maxWidth: "30%", minWidth: "30%" }}>
        <NavLink
          className="d-grid gap-2"
          to={`${langPrefix}/${t("_route.shop")}/${item.slug}`}
        >
          <Image
            rounded
            className="mw-100 m-auto mt-0 mb-0"
            role="button"
            src={item.image}
          />
        </NavLink>
      </div>

      <ul style={{ listStyle: "none" }}>
        <li className="list-group-item">
          <NavLink
            className="d-grid gap-2 fw-bold"
            to={`${langPrefix}/${t("_route.shop")}/${item.slug}`}
          >
            {item.name}
          </NavLink>
        </li>
        <li className="mb-2">{item.sku}</li>

        <li>{displayItemTotal(item)}</li>

        {item.attributes?.map(
          (attribute: ICartItemAttribute, index: number) => (
            <li key={index}>
              {`${attribute.option.label[lang].trim()}: ${attribute.option_value.label[lang]}`}
            </li>
          ),
        )}

        <li>
          {`${t("total_area")}: ${formatArea(item.area * item.quantity, lang)}`}
        </li>
        <li>
          {`${t("total_weight")}: ${formatWeight(item.weight * item.quantity)}`}
        </li>
        <li>{`${t("price_per_panel")}: ${formatMoney(item.list / 100)}`}</li>
      </ul>

      <div className="ms-auto">
        {t("Qty")}:&nbsp;{item.quantity}
      </div>
    </div>
  );
};

export default CartItemInfo;
